import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

/**
 * resources is an object that contains all the translations for the different languages.
 */
const resources = {
	en: {
		translation: {
			comms_input_placeholder: "Send message...",
			comms_emojiButton_placeholder: "Search emojis...",

			comms_imageModal_title: "Upload Images",
			comms_imageModal_placeholder: "Drag and drop or Click to upload images",
			comms_imageModal_submit: "Upload",
			comms_imageModal_doneButton: "Done",
			comms_imageModal_warning1: "Error. 3 images allowed at a time!",
			comms_imageModal_warning2: "Error. Only images are allowed!",

			comms_loading: "Please wait. Chats are loading ...",
			comms_noChats: "No chats history found",
			comms_operationError: "Communications Error. Operation not allowed",
			comms_paramsMissing: "Communications Error. Driver or Warehouse URL field not found",
			comms_accessDenied: "Access denied. Your session is invalid or has expired — please reopen this page from Dynamics",
			comms_salesConversation: "Sales conversation",

		},
	},
	es: {
		translation: {
			comms_input_placeholder: "Enviar mensaje...",
			comms_emojiButton_placeholder: "Buscar emojis...",

			comms_imageModal_title: "Subir Imágenes",
			comms_imageModal_placeholder: "Arrastra y suelta o haz clic para subir imágenes",
			comms_imageModal_submit: "Subir",
			comms_imageModal_doneButton: "Hecho",
			comms_imageModal_warning1: "Error. ¡Se permiten 3 imágenes a la vez!",
			comms_imageModal_warning2: "Error. ¡Solo se permiten imágenes!",

			comms_loading: "Por favor, espera. Los chats se están cargando...",
			comms_noChats: "No se encontró historial de chats",
			comms_operationError: "Error de comunicaciones. Operación no permitida",
			comms_paramsMissing: "Error de comunicaciones. Campo de URL de conductor o almacén no encontrado",
			comms_accessDenied: "Acceso denegado. Su sesión no es válida o ha expirado; vuelva a abrir esta página desde Dynamics",
			comms_salesConversation: "Conversación de ventas",

		},
	},
	ar: {
		translation: {
			comms_input_placeholder: "إرسال الرسالة...",
			comms_emojiButton_placeholder: "البحث عن الرموز التعبيرية...",

			comms_imageModal_title: "رفع الصور",
			comms_imageModal_placeholder: "اسحب وأفلت أو انقر لتحميل الصور",
			comms_imageModal_submit: "رفع",
			comms_imageModal_doneButton: "تم",
			comms_imageModal_warning1: "خطأ. يُسمح بثلاث صور فقط في كل مرة!",
			comms_imageModal_warning2: "خطأ. الصور فقط مسموح بها!",

			comms_loading: "يرجى الانتظار. يتم تحميل الدردشات...",
			comms_noChats: "لم يتم العثور على تاريخ الدردشات",
			comms_operationError: "خطأ في الاتصالات. العملية غير مسموح بها",
			comms_paramsMissing: "خطأ في الاتصالات. لم يتم العثور على حقل URL للسائق أو المستودع",
			comms_accessDenied: "تم رفض الوصول. جلستك غير صالحة أو منتهية الصلاحية — يرجى إعادة فتح هذه الصفحة من Dynamics",
			comms_salesConversation: "محادثة المبيعات",

		}
	},
	fr: {
		translation: {
			comms_input_placeholder: "Envoyer un message...",
			comms_emojiButton_placeholder: "Rechercher des emojis...",

			comms_imageModal_title: "Télécharger des images",
			comms_imageModal_placeholder: "Glissez-déposez ou cliquez pour télécharger des images",
			comms_imageModal_submit: "Télécharger",
			comms_imageModal_doneButton: "Terminé",
			comms_imageModal_warning1: "Erreur. 3 images autorisées à la fois!",
			comms_imageModal_warning2: "Erreur. Seules les images sont autorisées!",

			comms_loading: "Veuillez patienter. Chargement des discussions...",
			comms_noChats: "Aucun historique de discussions trouvé",
			comms_operationError: "Erreur de communication. Opération non autorisée",
			comms_paramsMissing: "Erreur de communication. Champ URL du conducteur ou de l'entrepôt introuvable",
			comms_accessDenied: "Accès refusé. Votre session est invalide ou a expiré — veuillez rouvrir cette page depuis Dynamics",
			comms_salesConversation: "Conversation commerciale",

		}
	},
	zh: {
		translation: {
			comms_input_placeholder: "发送消息...",
			comms_emojiButton_placeholder: "搜索表情符号...",

			comms_imageModal_title: "上传图片",
			comms_imageModal_placeholder: "拖放或点击上传图片",
			comms_imageModal_submit: "上传",
			comms_imageModal_doneButton: "完成",
			comms_imageModal_warning1: "错误。一次最多允许上传 3 张图片！",
			comms_imageModal_warning2: "错误。只允许上传图片！",

			comms_loading: "请稍候。聊天正在加载...",
			comms_noChats: "未找到聊天历史记录",
			comms_operationError: "通讯错误。不允许的操作",
			comms_paramsMissing: "通讯错误。未找到司机或仓库的 URL 字段",
			comms_accessDenied: "访问被拒绝。您的会话无效或已过期——请从 Dynamics 重新打开此页面",
			comms_salesConversation: "销售对话",

		}
	}};

/**
 * i18n is initialized with the resources object and the language to use.
 * The keySeparator option is set to false because we do not use keys in form messages.welcome.
 * The interpolation option is set to false because we do not use interpolation in form messages.welcome.
 */
i18n.use(initReactI18next) // passes i18n down to react-i18next
	.init({
		resources,
		lng: 'en',
		fallbackLng: 'en', // fallback language
		keySeparator: false, // we do not use keys in form messages.welcome
		interpolation: {
			escapeValue: false // react already safes from xss
		}
	});

export default i18n;